import { useQuery } from "@tanstack/react-query";
import { fetchDeductionConsents } from "./api";
import { DeductionConsentsQueryParams } from "./models";

export const useFetchDeductionConsents = (
  params: DeductionConsentsQueryParams,
  enabled = true
) =>
  useQuery({
    queryKey: ["deductionConsents", params],
    queryFn: ({ signal }) => fetchDeductionConsents(params, { signal }),
    enabled,
    staleTime: 30000,
  });

